const PASSKEY_ENROLLMENT_DISMISSED_KEY = "ilovemacumba:passkey:enrollment-dismissed";
const DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000;

type DismissedState = {
  dismissedAt: string;
};

export function isPasskeyEnrollmentDismissed(): boolean {
  try {
    const raw = localStorage.getItem(PASSKEY_ENROLLMENT_DISMISSED_KEY);
    if (!raw) {
      return false;
    }

    const parsed = JSON.parse(raw) as DismissedState;
    const dismissedAt = new Date(parsed.dismissedAt).getTime();
    if (Number.isNaN(dismissedAt)) {
      return false;
    }

    return Date.now() - dismissedAt < DISMISS_TTL_MS;
  } catch {
    return false;
  }
}

export function dismissPasskeyEnrollmentPrompt(): void {
  const payload: DismissedState = {
    dismissedAt: new Date().toISOString(),
  };
  localStorage.setItem(
    PASSKEY_ENROLLMENT_DISMISSED_KEY,
    JSON.stringify(payload),
  );
}

export function clearPasskeyEnrollmentDismissal(): void {
  localStorage.removeItem(PASSKEY_ENROLLMENT_DISMISSED_KEY);
}
